const seconds = 7
export const POPUP_TIME = seconds * 1000;